module.exports = __webpack_public_path__ + "media/react/organisms/video_player/assets/icon-8f705ce1c18285438f6037bac3e5ee6b.svg";